/* eslint-disable max-statements */
import { Dropdown } from 'primereact/dropdown';
import { TabPanel, TabView } from 'primereact/tabview';
import { Panel } from 'primereact/panel';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { EDSMyMetricTab } from '../../components/edsMyMetricTab/EDSMyMetricTab';
import { HaltReinitiate } from '../../components/haltReinitiate/HaltReinitiate';
import MessageInfo from '../../components/messageInfo/MessageInfo';
import { PrimaryApprovalScorecardStatus } from '../../components/primaryApprovalScorecardStatus/PrimaryApprovalScorecardStatus';
import { ScoreCardDashboardViewTable } from '../../components/scoreCardDashboardTable/ScoreCardDashboardViewTable';
import { ScoreCardEds } from '../../components/scoreCardEds/ScoreCardEds';
import { ScoreCardFilter } from '../../components/scoreCardFilter/ScoreCardFilter';
import {
    useGetScoreCardRoleIdQuery,
    useGetScorecardAgentsQuery,
} from '../../components/scoreCardFilter/scoreCardFilterSlice';
import { ScorecardDisputesTable } from '../../components/scorecardDisputesTable/ScorecardDisputesTable';
import { TeamLeadPayoutDetails } from '../../components/teamLeadPayoutDetails/TeamLeadPayoutDetails';
import { EdsExceptionGroupAssignment } from '../../features/edsDashboard/edsExceptionGroupAssignment/edsExceptionGroupAssignment';
import { EdsExceptionTabScoreCardAssignments } from '../../features/edsDashboard/edsExceptionScorecardAssignment/edsExceptionScoreCardAssignment';
import { EdsExceptionTabStartDate } from '../../features/edsDashboard/edsExceptionStartDate/edsExceptionStartDate';
import { EmployeeDimensionHistory } from '../../features/edsDashboard/employeeDimensionHistory/EmployeeDimensionHistory';
import { Recalculation } from '../../features/edsDashboard/recalculation/Recalculation';
import { selectCurrentEmpid, selectCurrentUser } from '../../pages/login/authSlice';
import {
    useGetScoreCardDisputesQuery,
    useGetTeamLeadScorecardAgentsQuery,
} from '../scorecardDashboard/scorecardDashboardSlice';
import './edsDashboard.scss';
import { loadSCfilDate } from '../../utils/dateStorage';
import { ScorecardPizzaTracker } from '../../components/scorecardPizzaTracker/ScorecardPizzaTracker';

export const EdsDashboard = () => {
    const [agentNumber, setAgentNumber] = useState<any>();
    const [agentName, setAgentName] = useState<any>();
    const [scoreCardName, setScoreCardName] = useState<any>();
    const loggedUser = useSelector(selectCurrentUser);
    const loggedEmpNum = useSelector(selectCurrentEmpid);

    //need to set the values based on scorecard filters
    const [inputMonth, setMonth] = useState(new Date().getMonth() + 1);
    const [inputYear, setYear] = useState(new Date().getFullYear());
    const [supervisorNumber, setSupervisorNumber] = useState();
    const supervisorDisable = false;
    const inputReadonly = true;
    const [inputScorecardVersion, setInputScorecardVersion] = useState<any>('');
    const [inputScorecardId, setInputScorecardId] = useState<any>('');
    const [tlAgentData, setTlAgentData] = useState<any>([]);
    const [scoreCardDisputeData, setScoreCardDisputeData] = useState<any>([]);
    const [scoreCardRoleIdValue, setScoreCardRoleIdValue] = useState<any>();
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [isEmpDimensionsHistory, setIsEmpDimensionsHistory] = useState<boolean>(true);
    const [recalcutionAssoTab, setRecalcutionAssoTab] = useState<boolean>(false);
    const [recalcutionTab, setRecalcutionTab] = useState<string>('scorecard');
    const toast = useRef<Toast>(null);

    const { data: scorecardSupervisorsData } = useGetScorecardAgentsQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
            scorecardRoleId: 2,
        },
        { skip: !inputYear || !inputMonth || !inputScorecardVersion }
    );
    const { data: scoreCardDisputesData } = useGetScoreCardDisputesQuery(
        {
            // employeenumber: supervisorNumber,
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
        },
        { skip: !inputScorecardVersion }
    );
    const { data: teamLeadScorecardAgentData, isFetching: edsTLScAgentDataIsFetching } =
        useGetTeamLeadScorecardAgentsQuery(
            {
                // employeenumber: supervisorNumber,
                year: inputYear,
                month: inputMonth,
                scorecardVersionId: inputScorecardVersion,
            },
            { skip: !inputScorecardVersion }
        );

    const { data: scorecardAgentsData } = useGetScorecardAgentsQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
            scorecardRoleId: 1,
        },
        { skip: !inputYear || !inputMonth || !inputScorecardVersion }
    );
    
    const [scorecardAgentsDataLoc,setscorecardAgentsDataLoc]=useState(null);
    useEffect(() => {  
        setscorecardAgentsDataLoc(null);
        setscorecardAgentsDataLoc(scorecardAgentsData?.data);
    },[scorecardAgentsData,inputYear,inputMonth,inputScorecardVersion]
    );

    const { data: scorecardRoleId } = useGetScoreCardRoleIdQuery(
        {
            employeenumber: agentNumber,
        },
        { skip: !agentNumber }
    );

    const onScoreCardChange = (value: any) => {
        if (value !== undefined && value !== '' && value !== null) {
            if (value.month !== '') setMonth(value.month);
            if (value.year !== '') setYear(value.year);
            setInputScorecardVersion(value.scorecardVersionId);
            setInputScorecardId(value.scorecardId);
            setScoreCardName(value.scorecardName);
        } else {
            setMonth(new Date().getMonth() + 1);
            setYear(new Date().getFullYear());
            setInputScorecardVersion('');
            setInputScorecardId('');
            setScoreCardName('');
            setAgentName('');
            setAgentNumber(0);
        }
    };
    const onAgentNameChange = (e: any) => {
        setAgentName(e);
    };
    const SupervisorOnChange = (e: any) => {
        setSupervisorNumber(e.value);
    };

    useEffect(() => {
        const tlAgentsData: any = [];
        if (teamLeadScorecardAgentData?.data?.length > 0) {
            teamLeadScorecardAgentData.data.forEach((element: any) => {
                if (element.review_status_id === 3) {
                    tlAgentsData.push(element);
                }
            });
        }
        setTlAgentData({ data: tlAgentsData });
    }, [teamLeadScorecardAgentData]);
    useEffect(() => {
        const disputesData: any = [];
        if (scoreCardDisputesData?.data?.length > 0) {
            scoreCardDisputesData.data.forEach((element: any) => {
                if (element.disputeStatusID === 1) {
                    disputesData.push(element);
                }
            });
        }
        setScoreCardDisputeData(disputesData);
    }, [scoreCardDisputesData]);

    useEffect(() => {
        if (scorecardRoleId?.data.length > 0) {
            if (
                scorecardRoleId?.data[0]?.manager_level !== undefined ||
                scorecardRoleId?.data[0]?.manager_level !== null
            ) {
                if (scorecardRoleId?.data[0].manager_level.indexOf('Non') > -1) {
                    setScoreCardRoleIdValue(1);
                } else {
                    setScoreCardRoleIdValue(2);
                }
            }
        }
    }, [scorecardRoleId]);

    useEffect(() => {
        const storedDate = loadSCfilDate();
        if (storedDate) {
            setMonth(storedDate.getMonth() + 1);
            setYear(storedDate.getFullYear());
        }
    }, []);

    useEffect(() => {
        if (activeIndex === 6) {
            setIsEmpDimensionsHistory(true);
        } else {
            setIsEmpDimensionsHistory(false);
        }
    }, [activeIndex]);

    useEffect(() => {
        if (activeIndex === 9) {
            if (recalcutionAssoTab) setRecalcutionTab('associate');
            else setRecalcutionTab('scorecard');
        }
    }, [recalcutionAssoTab]);

    return (
        <div>
            <ScoreCardFilter
                menuName={'EdsDashboard'}
                agentNumber={setAgentNumber}
                scorecardData={onScoreCardChange}
                agentName={onAgentNameChange}
                filterSCValue={setInputScorecardVersion}
                filterSCName={setScoreCardName}
                filterMonth={setMonth}
                filterYear={setYear}
                isEmpDimensionsHistory={isEmpDimensionsHistory}
                recalcutionTab={recalcutionTab}
                edsActiveIndex={activeIndex}
            />
             { inputScorecardVersion > 0 &&
                <Panel
                    header="Scorecard Status"
                    toggleable
                    className="card mt-4 me-4 ms-4 shadow bg-body rounded border-0"
                >
                    <ScorecardPizzaTracker
                        inputYear={inputYear}
                        inputMonth={inputMonth}
                        inputScorecardVersion={inputScorecardVersion}
                        fromCompensation
                    />
                </Panel>
            }
            <div className="card mt-4">
                <Toast ref={toast} />
                {agentNumber != null ? (
                    ''
                ) : (
                    <div style={{ display: 'none' }}>
                        <div className="row mt-3">
                            <div className="col-3">
                                <p className="me-3 mt-3 ms-3" style={{ marginBottom: '-5px' }}>
                                    Select Team Lead
                                </p>
                                <Dropdown
                                    disabled={supervisorDisable}
                                    value={supervisorNumber}
                                    onChange={SupervisorOnChange}
                                    options={scorecardSupervisorsData?.data}
                                    optionValue={'agent_number'}
                                    optionLabel={'agent_name'}
                                    placeholder={'Select Team Lead'}
                                    className="shadow rounded-start me-3 mt-3 ms-3"
                                />
                            </div>
                        </div>
                        <hr />
                    </div>
                )}

                <TabView
                    scrollable
                    activeIndex={activeIndex}
                    onTabChange={(e) => {
                        setActiveIndex(e.index);
                    }}
                >
                    <TabPanel header="MyMetric" leftIcon="metricsBtnIcon">
                        <EDSMyMetricTab
                            key={`${inputScorecardVersion}-${inputYear}-${inputMonth}`}
                            scorecardAgentsData={scorecardAgentsDataLoc}
                            empName={loggedUser}
                            scorecardVersionId={inputScorecardVersion}
                            inputMonth={inputMonth}
                            inputYear={inputYear}
                        />
                    </TabPanel>
                    <TabPanel header="Associate Dispute" leftIcon="disputeBtnIcon">
                        {tlAgentData?.data?.length > 0 ? (
                            <div className="row mt-4">
                                <div className="col-12">
                                    <div className="card shadow bg-body rounded border-0">
                                        <div className="card-body">
                                            {/* <span>Team Stats</span> */}
                                            <ScoreCardDashboardViewTable
                                                enableNavigateAgent={false}
                                                ScoreCardAgentdata={tlAgentData}
                                                inputMonth={inputMonth}
                                                inputYear={inputYear}
                                                isFetching={edsTLScAgentDataIsFetching}
                                                scorecardVersion={inputScorecardVersion}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <MessageInfo
                                title="No results found."
                                message="Try adjusting the Scorecard filters above."
                                rowHeight="15vh"
                            />
                        )}
                    </TabPanel>
                    <TabPanel header="Scorecard" leftIcon="scorecardTabBtnIcon">
                        <ScoreCardEds
                            //  date={date}
                            inputMonth={inputMonth}
                            inputYear={inputYear}
                            inputScorecardVersion={inputScorecardVersion}
                            module="eds"
                        />
                    </TabPanel>
                    <TabPanel header="Scorecard Dispute" leftIcon="disputeBtnIcon">
                        {scoreCardDisputeData && inputScorecardVersion !== null ? (
                            <ScorecardDisputesTable
                                scorecardVersion={inputScorecardVersion}
                                data={scoreCardDisputeData}
                                isSubTab
                            />
                        ) : (
                            <MessageInfo
                                title="No results found."
                                message="Try adjusting the month."
                                rowHeight="15vh"
                            />
                        )}
                    </TabPanel>
                    <TabPanel header="Exception" leftIcon="exceptionBtnIcon">
                        <div className="col-md-12">
                            <div className="card border-0">
                                <div className="card-body border-0">
                                    <h3 style={{ fontWeight: '400' }}>Exceptions</h3>
                                    <TabView>
                                        <TabPanel header="Start Date" leftIcon="windowsTabBtnIcon">
                                            <EdsExceptionTabStartDate
                                                agentNumber={agentNumber}
                                                loggedEmpNum={loggedEmpNum}
                                                inputScorecardVersion={inputScorecardVersion}
                                                inputScorecardId={inputScorecardId}
                                                scoreCardRoleIdValue={scoreCardRoleIdValue}
                                                scoreCardName={scoreCardName}
                                                agentName={agentName}
                                            />
                                        </TabPanel>
                                        <TabPanel header="Scorecard Assignment" leftIcon="windowsTabBtnIcon">
                                            <EdsExceptionTabScoreCardAssignments
                                                agentNumber={agentNumber}
                                                loggedEmpNum={loggedEmpNum}
                                                scorecardId={inputScorecardId}
                                                scoreCardRoleIdValue={scoreCardRoleIdValue}
                                                scoreCardName={scoreCardName}
                                                agentName={agentName}
                                                inputMonth={inputMonth}
                                                inputYear={inputYear}
                                            />
                                        </TabPanel>
                                        <TabPanel header="Group Assignment" leftIcon="windowsTabBtnIcon">
                                            <EdsExceptionGroupAssignment
                                                scorecardVersionId={inputScorecardVersion}
                                                scorecardId={inputScorecardId}
                                                inputMonth={inputMonth}
                                                loggedEmpNum={loggedEmpNum}
                                                inputYear={inputYear}
                                                scoreCardName={scoreCardName}
                                            />
                                        </TabPanel>
                                    </TabView>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Windows" leftIcon="windowsTabBtnIcon">
                        <PrimaryApprovalScorecardStatus
                            inputScorecardVersion={inputScorecardVersion}
                            inputYear={inputYear}
                            inputMonth={inputMonth}
                            inputReadonly={inputReadonly}
                            via={'EdsDashboard'}
                        />
                    </TabPanel>
                    <TabPanel header="Employee Dimension History" leftIcon="disputeBtnIcon">
                        <EmployeeDimensionHistory
                            inputYear={inputYear}
                            inputMonth={inputMonth}
                            agentNumber={agentNumber}
                        />
                    </TabPanel>
                    <TabPanel header="Team Lead Payout">
                        <TeamLeadPayoutDetails
                            inputScorecardVersion={inputScorecardVersion}
                            inputYear={inputYear}
                            inputMonth={inputMonth}
                            inputRoleId={2}
                        />
                    </TabPanel>
                    <TabPanel header="Halt and Reinitiate">
                        <div className="card shadow bg-body rounded mt-4 border-0">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <HaltReinitiate
                                            inputMonth={inputMonth}
                                            inputYear={inputYear}
                                            inputScorecardVersion={inputScorecardVersion}
                                            scorecardName={scoreCardName}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Recalculation" style={{ paddingRight: '2rem' }}>
                        <Recalculation
                            agentNumber={agentNumber}
                            inputScorecardVersion={inputScorecardVersion}
                            scoreCardRoleIdValue={scoreCardRoleIdValue}
                            agentName={agentName}
                            inputMonth={inputMonth}
                            inputYear={inputYear}
                            recalcutionAssoTab={setRecalcutionAssoTab}
                        />
                    </TabPanel>
                </TabView>
            </div>
        </div>
    );
};
